<template>
  <path
    d="M20.54 5.23018L19.15 3.55018C18.88 3.21018 18.47 3.00018 18 3.00018H6C5.53 3.00018 5.12 3.21018 4.84 3.55018L3.46 5.23018C3.17 5.57018 3 6.02018 3 6.50018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V6.50018C21 6.02018 20.83 5.57018 20.54 5.23018ZM11.65 17.1502L6.5 12.0002H10V10.0002H14V12.0002H17.5L12.35 17.1502C12.16 17.3402 11.84 17.3402 11.65 17.1502ZM5.12 5.00018L5.93 4.00018H17.93L18.87 5.00018H5.12Z"
  />
</template>
